import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import {
  UntypedFormGroup,
  FormControl,
  Validators,
  FormGroup,
} from "@angular/forms";
import { FileInput } from "src/app/models/support";

@Component({
    selector: "otp-ticket",
    templateUrl: "./otp-ticket.component.html",
    styleUrls: ["./otp-ticket.component.scss"],
    standalone: false
})
export class OtpTicketComponent implements OnInit, OnChanges {
  @Input() form: FormGroup;
  @Input() isVisible: boolean = false;
  @Input() category: string;
  constructor() {}

  ngOnInit(): void {}

  onFileSelect(file:FileInput, name: string) {
    this.form.get(name).setValue({
      name: file.file.name,
      content: file.base64,
    });
  }

  onFileRemove(name: string) {
    this.form.get(name).reset();
  }

  markAsTouched(name: string) {
    this.form.get(name).markAsTouched();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.category) {
      if (this.isVisible) this.initiateForm();
    }
  }

  initiateForm() {
    this.form.addControl(
      "personalPhoto",
      new FormControl("", [Validators.required])
    );
    this.form.addControl(
      "passport",
      new FormControl("", [Validators.required])
    );

    this.form.addControl("message", new FormControl(""));
  }
}
